import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoinType } from '../models/CoinType';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CoinTypeService {
  private baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/CoinTypes`;

  constructor(private http: HttpClient) {}

  getCoinTypes(): Observable<CoinType[]> {
    return this.http.get<CoinType[]>(this.baseUrl);
  }

  addCoinType(coinType: CoinType): Observable<CoinType> {
    return this.http.put<CoinType>(`${this.baseUrl}/add`, coinType);
  }

  updateCoinType(coinType: CoinType): Observable<CoinType> {
    return this.http.post<CoinType>(`${this.baseUrl}/update`, coinType);
  }
}
